"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-3f909cc0"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { class: "tw-fixed tw-inset-0 tw-flex tw-items-start tw-justify-end tw-px-4 tw-py-6 sm:tw-p-6 tw-pointer-events-none tw-z-[9999999]" };
var _hoisted_2 = { class: "tw-max-w-sm tw-w-full" };
var Notification_vue_1 = require("./Notification.vue");
var store_1 = require("./store");
exports.default = (0, vue_1.defineComponent)({
    name: 'NotificationProvider',
    setup: function (__props) {
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createVNode)(vue_2.TransitionGroup, {
                            appear: "",
                            tag: "div",
                            "enter-active-class": (0, vue_2.unref)(store_1.default).getters.getNotificationsCount() > 1 ? 'tw-transform tw-ease-out tw-delay-300 tw-duration-300 tw-transition' : 'tw-transform tw-ease-out tw-duration-300 tw-transition',
                            "enter-from-class": "tw-translate-x-4 tw-opacity-0",
                            "enter-to-class": "tw-translate-x-0 tw-opacity-100",
                            "leave-active-class": "tw-transition tw-ease-in tw-duration-100",
                            "leave-from-class": "tw-opacity-100",
                            "leave-to-class": "tw-opacity-0",
                            "move-class": "tw-transition tw-ease-in-out tw-duration-500"
                        }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(store_1.default).getters.getNotifications(), function (notification, idx) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Notification_vue_1.default, {
                                        key: notification.id,
                                        notification: notification,
                                        class: (0, vue_2.normalizeClass)(idx > 0 ? 'tw-mt-4' : '')
                                    }, null, 8, ["notification", "class"]));
                                }), 128))
                            ]; }),
                            _: 1
                        }, 8, ["enter-active-class"])
                    ])
                ]),
                (0, vue_2.renderSlot)(_ctx.$slots, "default")
            ], 64));
        };
    }
});
